import { AuthService } from '@ortho-next/auth-core';
import { AppConfiguration } from './core';


/**
* Authentication configuration for application.
*/
export function getAuthConfig(configs: AppConfiguration) {
	return {
		allowedUrls: [
			configs.domainUserAPI,
			configs.domainPatientAPI,
			configs.domainTspAPI
		],
		appSSOutUriApi: configs.appSSOutUriApi,
		applicationScope: configs.b2cApplicationScope,
		clientId: configs.b2cClientId,
		idleTimeToEndSession: configs.idleTimeToEndSession,
		tenantName: configs.b2cTenantName,
		resetPasswordPolicyId: configs.b2cResetPasswordPolicyId,
		signInPolicyId: configs.b2cSignInPolicyId,
		changePasswordPolicyId: configs.b2cChangePasswordPolicyId,
		showDebugInformation: configs.envName !== 'production'
	};
}

export function initAuth(authSrv: AuthService) {
	return authSrv.runInitialLoginSequence();
}

export const DEFAULT_APP_VERSION = '2.1.0';